import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    container: {
        backgroundColor: palette.grey[50],
        p: 4,
        border: `1px solid ${palette.border.primary}`,
        borderRadius: 1,
        width: '100%',
    },
    assignedToContainer: {
        backgroundColor: palette.background.default,
        p: 2,
        border: `1px solid ${palette.border.primary}`,
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'space-between',
    },
    assignedToTitleContainer: {
        mb: 1,
    },
    header: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
    },
    taskDetailsContainer: {
        mt: 3,
    },
    taskDetail: {
        mt: 3,
        display: 'grid',
        gridTemplateColumns: '100px 1fr',
    },
}

export const AssignedToStyles: moduleStyleType = {
    assignedToContainer: {
        backgroundColor: 'background.default',
        padding: 2,
        border: `1px solid ${palette.border.primary}`,
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'space-between',
    },
    assignedToTitleContainer: {
        marginBottom: 1,
    },
}

export const AssignUserStyles: moduleStyleType = {
    container: {
        padding: 2,
        borderColor: 'border.subtle',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: 1,
        backgroundColor: 'background.default',
        borderLeftWidth: '6px',
        borderLeftColor: 'primary.main',
    },
    assignUserContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    noApproverDisplay: {
        flexGrow: 1,
        marginRight: 1,
    },
}

export const ActionableUserListContainerStyles: moduleStyleType = {
    container: {
        mt: 2,
        mb: 1,
    },
    userListContainer: {
        my: 1,
    },
}
